<template>
    <div>
        
        <h3>Visitor Process</h3>
        <template v-if="!isAdmin">
        <p>The website helps visitors enter the building quickly and easily, please confirm/provide the following details <b>for visitors</b></p>
        <p class="margin_bottom">Some options may have been defaulted based on answers to amentities questions</p>
         </template>


        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label top_pad_med">
                Visitors' Hours
            </label>
            <div class="md-layout-item md-size-60">
                <md-switch v-model="visitorProcess.openingHours24">24 Hour Access</md-switch>
                <zoom-center-transition :duration="600" v-show="visitorProcess.openingHours24 === false">
                    <md-field>
                        <md-input type="text" v-model="visitorProcess.openingHoursTimesText" placeholder="Describe building access times" />
                        <span class="md-helper-text">e.g. "9:00-17:00 working days" or "8:00-19:00 weekdays, 9:00-12:00 weekends / public holidays"</span>
                    </md-field>
                </zoom-center-transition>
            </div>
        </div>

        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label">
                Visitors' Hours Text
            </label>
            <div class="md-layout-item md-size-60">
                <FadeTransition :duration="400" mode="out-in" v-if="openingHoursTextVisible">
                    <ValidationProvider name="Visitors' Hours Text" rules="required|min:15|max:90" v-slot="{ passed, failed }">
                        <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <md-input type="text" v-model="visitorProcess.openingHoursText" />
                            <span class="md-helper-text">This text will be displayed on website</span>
                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>
                </FadeTransition>
                <FadeTransition :duration="400" mode="out-in" v-else>
                    <!--N.B. this is neat way to 'fake' validation i.e. this disabled field is always longer than 1, so effectively alows us to validate the md-field above despite it being v-if=false  --> 
                    <ValidationProvider name="Visitors' Hours Text" rules="max:1" v-slot="{ passed, failed }">
                        <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <md-input disabled value="Provide visitors' access times above"></md-input>
                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>
                </FadeTransition>
            </div>
        </div>









        <div class="md-layout md-gutter" :class="{ margin_bottom : !receptionChosen }">
            <label class="md-layout-item md-size-25 md-form-label top_pad_med">
                Visitors' Reception
            </label>
            <div class="md-layout-item md-size-60">
                <md-switch v-model="visitorProcess.reception">Manned Reception</md-switch>
                <zoom-center-transition :duration="600" v-show="receptionChosen">
                    <div>
                        <md-radio v-model="visitorProcess.reception24" :value="true">24 Hours</md-radio>
                        <md-radio v-model="visitorProcess.reception24" :value="false">Times...</md-radio>
                        <FadeTransition :duration="400" mode="out-in" v-if="visitorProcess.reception24 === false">
                            <md-field>
                                <md-input type="text" v-model="visitorProcess.receptionTimesText" placeholder="Describe opening times" />
                                <span class="md-helper-text">e.g. "9:00-17:00 working days" or "8:00-19:00 weekdays, 9:00-12:00 weekends / public holidays"</span>
                            </md-field>
                        </FadeTransition>
                    </div>
                </zoom-center-transition>
            </div>
        </div>

        <zoom-center-transition :duration="1000" v-if="receptionChosen">
            <div class="md-layout md-gutter margin_bottom">
                <label class="md-layout-item md-size-25 md-form-label">
                    Visitors' Reception Hours Text
                </label>
                <div class="md-layout-item md-size-60">
                    <FadeTransition :duration="400" mode="out-in" v-if="receptionTextVisible">
                        <ValidationProvider name="Visitors' Reception Hours Text" rules="required|min:15|max:90" v-slot="{ passed, failed }">
                            <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                <md-input type="text" v-model="visitorProcess.receptionText" />
                                <span class="md-helper-text">This text will be displayed on website</span>
                                <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                            </md-field>
                        </ValidationProvider>
                    </FadeTransition>
                    <FadeTransition :duration="400" mode="out-in" v-else>
                        <ValidationProvider name="Visitors' Reception Hours Text" rules="max:1" v-slot="{ passed, failed }">
                            <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                <md-input disabled value="Provide opening times above"></md-input>
                                <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                            </md-field>
                        </ValidationProvider>
                    </FadeTransition>
                </div>
            </div>
        </zoom-center-transition>



        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label top_pad_med">
                Building Access
            </label>
            <div class="md-layout-item md-size-60">
                <md-switch v-model="visitorProcess.accessControlSystem">Access Control System</md-switch>
            </div>
        </div>


        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label">
                Visitors' Entry
            </label>
            <div class="md-layout-item md-size-60">
                <ValidationProvider name="Visitors' Entry" rules="required|min:15|max:90" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input type="text" v-model="visitorProcess.entryText" placeholder="Describe how visitors enter the building" />
                        <span class="md-helper-text">e.g. "Please present yourself to reception at the main entrance" or "Please use intercom at the main entrance"</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>


        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label">
                Visitors' Sign In
            </label>
            <div class="md-layout-item md-size-60">
                <ValidationProvider name="Visitors' Sign In" rules="required|min:15|max:90" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input type="text" v-model="visitorProcess.arrivalText" placeholder="Describe how visitors enter the building" />
                        <span class="md-helper-text">e.g. "All visitors must sign in at reception, sign in sheet on desk when reception is closed" or "All visitors must sign in with the organisation they are visiting"</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>


    </div>
</template>
<script>
    import { SlideYDownTransition, FadeTransition, ZoomCenterTransition } from "vue2-transitions";
    import { extend } from "vee-validate";

    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);


    import Help from "@/ts/Help";

    export default {
        name: "BuildingAmenitiesInfo",
        props: {
            visitorProcess: null,
            isAdmin: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                openingHoursText24Hours: 'Building is accessible 24/7',
                receptionText24Hours: 'Reception is open 24/7',
            }
        },
        watch: {
            'visitorProcess.openingHours24': {
                immediate: true,
                handler(v) {
                    if (v)
                        this.visitorProcess.openingHoursText = this.openingHoursText24Hours;
                    else
                        this.visitorProcess.openingHoursText = this.openingHoursTextCalc(this.visitorProcess.openingHoursTimesText);
                }
            },
            'visitorProcess.openingHoursTimesText': {
                immediate: true,
                handler(v) {
                    if (!this.visitorProcess.openingHours24)
                        this.visitorProcess.openingHoursText = this.openingHoursTextCalc(v);
                }
            },
            'visitorProcess.reception': {
                immediate: true,
                handler(v) {
                    this.visitorProcess.entryText = this.entryTextCalc();
                    this.visitorProcess.arrivalText = this.arrivalTextCalc();
                }
            },
            'visitorProcess.reception24': {
                immediate: true,
                handler(v) {
                    if (v)
                        this.visitorProcess.receptionText = this.receptionText24Hours;
                    else
                        this.visitorProcess.receptionText = this.receptionTextCalc(this.visitorProcess.receptionTimesText);
                    this.visitorProcess.entryText = this.entryTextCalc();
                    this.visitorProcess.arrivalText = this.arrivalTextCalc();
                }
            },
            'visitorProcess.receptionTimesText': {
                immediate: true,
                handler(v) {
                    if (!this.visitorProcess.reception24)
                        this.visitorProcess.receptionText = this.receptionTextCalc(v);
                }
            },
            'visitorProcess.accessControlSystem': {
                immediate: true,
                handler(v) {
                    this.visitorProcess.entryText = this.entryTextCalc();
                }
            },

        },
        computed: {
            openingHoursTextVisible() {
                return ((this.visitorProcess.openingHours24 === true) || Help.isGoodString(this.visitorProcess.openingHoursTimesText))
            },
            receptionChosen() {
                return this.visitorProcess.reception === true;
            },
            receptionTextVisible() {
                return this.receptionChosen && ((this.visitorProcess.reception24 === true) || Help.isGoodString(this.visitorProcess.receptionTimesText));
            }
        },
        methods: {
            openingHoursTextCalc(openingTimesText) {
                return `Building is accessible ${openingTimesText}`;
            },
            receptionTextCalc(openingTimesText) {
                return `Reception is open ${openingTimesText}`;
            },
            entryTextCalc() {
                var respVal = "Please use intercom at the main entrance to enter";
                if (this.receptionChosen) {
                    if (this.visitorProcess.reception24 === true)
                        respVal = "Please present yourself to reception at the main entrance";
                    else if (this.visitorProcess.accessControlSystem === true)
                        respVal = "Please present to reception when open, use access control system when reception is closed";
                }
                else if (this.visitorProcess.accessControlSystem === true)
                    respVal = "Please use access control at the main entrance to enter";
                return respVal;
            },
            arrivalTextCalc() {
                var respVal = "All visitors must sign in with the organisation they are visiting";
                if (this.receptionChosen) {
                    if (this.visitorProcess.reception24 === true)
                        respVal = "All visitors must sign in at reception";
                    else
                        respVal = "All visitors must sign in at reception, sign in sheet on desk when reception is closed";
                }
                return respVal;
            }
        },
        components: {
            FadeTransition,
            ZoomCenterTransition,
            SlideYDownTransition
        }
    };
</script>
<style lang="scss">
    .card-title.spaced {
        margin-top: 5rem;
    }

    .question {
        margin-bottom: 3rem;
    }

    .count {
        margin-left: 1rem;
    }

    .md-button.md-just-icon {
        height: 30px;
    }

    .md-chip .md-ripple {
        text-transform: none;
    }

    .md-card .md-card-actions {
        border: none;
    }


    .md-card .md-card-content .md-form-label.top_pad_none {
        padding-top: 0px;
    }

    .md-card .md-card-content .md-form-label.top_pad_min {
        padding-top: 10px;
    }

    .md-card .md-card-content .md-form-label.top_pad {
        padding-top: 30px;
    }


    .md-card .md-card-content .md-form-label.top_pad_med {
        padding-top: 15px;
    }

    .md-checkbox,
    .md-radio {
        margin-top: 0rem;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

        .md-radio .md-radio-container {
            margin-left: 5px;
            position: relative;
            left: -3px;
        }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }
</style>
